export const THUMBNAIL_SIZE = 72;
export const THUMBNAIL_SIZE_XS = 56;

export const attachmentThumbnailStyles = {
	root: (clickable: boolean) => ({
		position: 'relative',
		width: THUMBNAIL_SIZE,
		height: THUMBNAIL_SIZE,
		cursor: clickable ? 'pointer' : 'default',
		flexShrink: 0,
		'@media (max-width: 600px)': {
			width: THUMBNAIL_SIZE_XS,
			height: THUMBNAIL_SIZE_XS
		}
	}),
	imageClip: {
		position: 'absolute',
		inset: 0,
		borderRadius: 1,
		border: '1px solid',
		borderColor: 'divider',
		backgroundColor: 'background.paper',
		overflow: 'hidden'
	},
	image: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		display: 'block'
	},
	uploadingOverlay: {
		position: 'absolute',
		inset: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.6)'
	},
	errorOverlay: {
		position: 'absolute',
		inset: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(211, 47, 47, 0.85)',
		color: 'common.white'
	},
	removeButton: {
		position: 'absolute',
		top: -8,
		right: -8,
		width: 20,
		height: 20,
		padding: 0,
		backgroundColor: 'background.paper',
		border: '1px solid',
		borderColor: 'divider',
		'&:hover': {
			backgroundColor: 'background.paper'
		},
		'& .MuiSvgIcon-root': {
			fontSize: 14
		}
	}
};
